import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import FilterComponent from 'main/components/tables/interactive/components/fancy_filter/filter_selector/FilterComponent';

const EmploymentStatus = observer(({filter, filterKey, filterUpdated, filterDeleted, Wrapper}) => {
  const options = [
    { label: t('components.tables.fancy_filters.selectors.Active'), value: 'non_terminated' },
    { label: t('components.tables.fancy_filters.selectors.Terminated'), value: 'terminated' }
  ];

  return <FilterComponent filter={filter} filterKey={filterKey} options={options} filterUpdated={filterUpdated} filterDeleted={filterDeleted} Wrapper={Wrapper}/>;
});

export default EmploymentStatus;
